import React from "react";
import LogoRodape from "../../images/rodape.png"; // ✅ caminho ajustado
import { FaWhatsapp } from "react-icons/fa"; // se não tiver: npm install react-icons

const Rodape = () => {
  return (
    <div className="w-full bg-gray-100 px-6 py-2 border border-[#dbdbdb] rounded-sm shadow">
      {/* Parte de cima - Texto do rodapé */}
      <div className="mb-2">
        <div className="text-sm text-gray-700 font-bold">
          Desenvolvido por Mega Sistema Informática - Control Service
        </div>
      </div>

      {/* Linha divisória */}
      <hr className="border-[#606060] mb-2" />

      {/* Parte de baixo - Logo + Botão WhatsApp */}
      <div className="flex items-center justify-between text-gray-500 text-sm font-semibold">
        <img
          src={LogoRodape}
          alt="Logo Rodapé"
          className="h-8 object-contain"
        />

        <a
          href="https://wa.me/5517996237020"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 px-4 py-2 rounded-md text-sm font-medium text-white transition-transform duration-200 hover:scale-105"
          style={{ backgroundColor: "#1d7f14" }}
        >
          <FaWhatsapp size={18} />
          Suporte técnico
        </a>
      </div>
    </div>
  );
};

export default Rodape;
